import { getDexieConnectionRefresh } from "./Dexie";

export const getDocumentsBymemberId = async (memberId: string) => {
    return await getDexieConnectionRefresh().documents.where('id').startsWith(`${memberId}-`)?.toArray();

};